export default "__VITE_ASSET__BPg2d1GA__"